import { sectionRenderer } from '@theme/section-renderer';

window.easifyAddToCartEvent = true;

const url = new URL(window.location.href);
if (url.searchParams.get('addToCart') === 'true') {
  url.searchParams.delete('addToCart');
  window.history.replaceState(window.history.state, '', url);
}

let pendingSync;
let revision = 0;

function scheduleCartSync(delay) {
  const currentRevision = ++revision;
  clearTimeout(pendingSync);
  pendingSync = setTimeout(() => syncAndOpenCart(currentRevision), delay);
}

async function syncAndOpenCart(currentRevision, attempt = 0) {
  const items = document.querySelector('cart-items-component[data-drawer]');
  const sectionId = items?.dataset.sectionId;

  if (!sectionId) {
    if (currentRevision === revision && attempt < 3) {
      pendingSync = setTimeout(() => syncAndOpenCart(currentRevision, attempt + 1), 150);
    }
    return;
  }

  try {
    const response = await fetch(Theme.routes.cart_url.replace(/\/$/, '') + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    });
    if (!response.ok) throw new Error('Cart refresh failed: ' + response.status);

    const cart = await response.json();
    if (currentRevision !== revision) return;

    const wasEmpty =
      items.querySelector('[data-cart-drawer-empty]') !== null || items.querySelector('.cart-drawer--empty') !== null;

    document.dispatchEvent(new CustomEvent('abris:cart-synced', { detail: { itemCount: cart.item_count } }));
    await sectionRenderer.renderSection(sectionId, {
      cache: false,
      mode: 'hydration',
      injectStylesheet: wasEmpty,
    });

    if (currentRevision !== revision) return;
    await customElements.whenDefined('theme-drawer');
    await new Promise((resolve) => requestAnimationFrame(resolve));

    const drawer = document.querySelector('theme-drawer#cart-drawer');
    if (typeof drawer?.open === 'function') drawer.open();
  } catch (error) {
    if (currentRevision === revision && attempt < 3) {
      pendingSync = setTimeout(() => syncAndOpenCart(currentRevision, attempt + 1), 250);
      return;
    }

    console.warn('[easify-tinker-cart] Cart synchronization failed:', error);
  }
}

document.addEventListener('easify:main-product:add', () => scheduleCartSync(900));
document.addEventListener('easify:add-on-product:add', () => scheduleCartSync(180));
